import { Injectable, OnDestroy } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AuthService } from '../services/auth.service'
import { FeatureFlagsService } from '../services/feature-flag.service'

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, OnDestroy {
  private isNewAuthFrontendEnabled: boolean
  private subscriptions = [
    this.featureFlagsService.newAuthFrontend$.subscribe(({ isEnabled })=>{
      this.isNewAuthFrontendEnabled = isEnabled
    })
  ]
  constructor (
    private auth: AuthService,
    private featureFlagsService: FeatureFlagsService
  ) { }

  canActivate (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.auth.isAuthenticated().pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true
        } else {
          const url = this.isNewAuthFrontendEnabled
            ? `${origin}/auth/login?redirect=/recap${state.url}`
            : `${origin}/login?redirect=/recap${state.url}`
          open(url, '_self')
          return false
        }
      })
    )
  }
  ngOnDestroy (): void {
    this.subscriptions.forEach((subscription)=>subscription.unsubscribe())
  }
}
